import { LeadsDataSource } from '../../../utils/apis/leadsApiUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
export const getLeadsByAgeSourceLink = (source, dateRange) => {
    if (source === LeadsDataSource.ICO) {
        return getNvisionAnalyzeLeadsUrl(dateRange);
    }
    return '';
};
export const leadsByAgeFormatter = (data) => {
    const { leadsByAge = [], lastUpdatedUTC = '' } = data || {};
    const totalLeadCount = leadsByAge.reduce((acc, v) => acc + v.externalLeads + v.internalLeads, 0);
    const chartData = leadsByAge
        .sort((a, b) => a.leadAge - b.leadAge)
        .map(({ leadAge, externalLeads, internalLeads }) => {
        const category = `${leadAge}`;
        return [
            {
                category,
                subcategory: 'External',
                value: externalLeads || 0,
            },
            {
                category,
                subcategory: 'Internal',
                value: internalLeads || 0,
            },
        ];
    })
        .flat();
    return {
        chartData,
        lastUpdatedUTC,
        totalLeadCount,
    };
};
